import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Change password", -1)
const _hoisted_2 = { class: "detail-item-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("New Password")
const _hoisted_4 = { class: "detail-item-container" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Confirm Password")
const _hoisted_6 = { class: "detail-item-container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Change password ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { class: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { size: "12" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_ion_label, { class: "detail-label" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  class: "detail-input",
                  type: "password",
                  placeholder: "New password",
                  modelValue: _ctx.newPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPassword = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { size: "12" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_ion_label, { class: "detail-label" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  class: "detail-input",
                  type: "password",
                  placeholder: "Confirm password",
                  modelValue: _ctx.confirmPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmPassword = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { size: "12" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_ion_button, {
                  onClick: _ctx.changePassword,
                  color: "success",
                  expand: "block",
                  disabled: this.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_ion_button, {
                  onClick: _ctx.close,
                  color: "danger",
                  expand: "block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (Object.keys(_ctx.errors).length > 0)
        ? (_openBlock(), _createBlock(_component_ion_row, {
            key: 0,
            class: "pad-bot"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (msg, index) => {
                    return (_openBlock(), _createBlock(_component_ion_text, {
                      class: "ion-text-center",
                      color: "danger",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode("p", null, _toDisplayString(msg[0]), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}